var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{style:(_vm.trStyle)},[_vm._l((_vm.emptyCellsCount),function(index){return _c('td',{key:("main-row empty-cell " + index),class:{
            'empty-cell': true,
            sticky: typeof _vm.mainData.Config.CountAnchoredColumns === 'number',
        },style:(("background-color: rgba(162, 93, 77, " + _vm.backgroundAlpha + ")"))})}),_vm._l((_vm.info.cells),function(cell,i){return [_c('td',{key:("aggregate-row" + (_vm.info.depth) + i),class:{
                'text-right': true,
                sticky: cell.sticky,
                last: cell.lastSticky,
            },style:(_vm.tdStyle)},[_vm._v(" "+_vm._s(cell.text)+" ")])]}),(_vm.isEditable)?_c('td',{class:{
            'sticky-actions': _vm.mainData.Config.IsAnchorActions,
        },style:(("background-color: rgba(162, 93, 77, " + _vm.backgroundAlpha + ")"))}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }